import React from 'react';
import { Grid, Typography } from '@mui/material';
import useCache from '../../app/useCache';
import { CachedEntity } from '../../app/cacheSlice';
import { useCurrentUser } from '../../app/useCurrentUser';
import RoleSelector from '../common/RoleSelector';

interface BulkImportRolesPanelProps {
    roleIds: number[];
    onChange: (ids: number[]) => void;
}

const BulkImportRolesPanel: React.FC<BulkImportRolesPanelProps> = ({ roleIds, onChange }) => {
    const roles = useCache(CachedEntity.Role);
    const [isAdmin] = useCurrentUser();

    return (
        <React.Fragment>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="body2" color="text.secondary" mb={1}>
                        Select roles to assign to all imported users.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <RoleSelector
                        roles={roles}
                        selectedIds={roleIds}
                        onChange={onChange}
                        disabled={!isAdmin}
                        height={380}
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default BulkImportRolesPanel;
